import { ResourceCornSchema, TagSchema } from '../tag.js';
export const AddTagToResourceBodyRequestSchema = TagSchema.pick({
    key: true,
    value: true,
    color: true,
}).partial({ value: true });
export const AddTagToResourcePathRequestSchema = ResourceCornSchema;
export const AddTagToResourceRequestSchema = AddTagToResourceBodyRequestSchema.and(AddTagToResourcePathRequestSchema);
export const AddTagToResourceResponseSchema = TagSchema;
